<app-sol-card>
    <div class="p-2 w-full">
        <p class="ds-subtitle-paragraph">
            {{ angularI18nService.t2('dialog-error', 'dialog.title') }}
            {{
                hiddenBtnWhatsapp
                    ? angularI18nService.t2('dialog-error', 'dialog.descriptionFirst')
                    : angularI18nService.t2('dialog-error', 'dialog.descriptionSecond')
            }}
        </p>
        <app-sol-button-actions *ngIf="hiddenBtnWhatsapp">
            <app-sol-button
                [type]="'primary'"
                [label]="angularI18nService.t2('dialog-error', 'dialog.buttonFirst')"
                (buttonClick)="redirectWhatsappProblem()"
            ></app-sol-button>
        </app-sol-button-actions>
        <app-sol-button-actions *ngIf="!hiddenBtnWhatsapp">
            <app-sol-button
                [type]="'primary'"
                [label]="angularI18nService.t2('dialog-error', 'dialog.buttonSecond')"
                (buttonClick)="reloadPage()"
            ></app-sol-button>
        </app-sol-button-actions>
    </div>
</app-sol-card>
